/**
 * Client site constants that are safe to import in both frontend and backend.
 * These are pure TypeScript constants with no dependencies on Node.js modules.
 */

export const ClientSiteStatus = {
  Active: 'active',
  Inactive: 'inactive',
  Suspended: 'suspended',
} as const

/**
 * Provenance of an automatically created ClientSite link, recorded in
 * `siteSpecificData.linkSource`. A row without one was created by a staff action,
 * a signup, or a Client import — the historical default.
 *
 * V1 stamped the same provenance on the rows it auto-created at check-in
 * (`insertclient(..., ['source' => 'Client API General Checking'])`), which is what
 * makes a visit-created link distinguishable from a real enrolment after the fact.
 */
export const ClientSiteLinkSource = {
  CheckIn: 'CHECK_IN',
  Import: 'IMPORT',
} as const

export const ImportSiteLinkCode = {
  WillBeAdded: 'SITE_LINK_WILL_BE_ADDED',
} as const

// TypeScript types
export type ClientSiteStatusValue = (typeof ClientSiteStatus)[keyof typeof ClientSiteStatus]
